// Scarcity Countdown Timer
class ScarcityTimer {
  constructor() {
    this.countdown = document.getElementById('scarcityCountdown');
    this.deliveryDate = document.getElementById('deliveryDate');

    if (!this.countdown) return;

    this.init();
  }

  init() {
    // Set countdown to 4-6 hours from now
    const hours = Math.floor(Math.random() * 3) + 4;
    this.targetTime = new Date().getTime() + (hours * 60 * 60 * 1000);

    // Set delivery date (3-4 business days from now)
    this.setDeliveryDate();

    // Start countdown
    this.updateCountdown();
    setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.targetTime - now;

    if (distance < 0) {
      // Reset timer
      const hours = Math.floor(Math.random() * 3) + 4;
      this.targetTime = new Date().getTime() + (hours * 60 * 60 * 1000);
      return;
    }

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const hoursEl = this.countdown.querySelector('.pdp-timer__hours');
    const minutesEl = this.countdown.querySelector('.pdp-timer__minutes');
    const secondsEl = this.countdown.querySelector('.pdp-timer__seconds');

    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  setDeliveryDate() {
    if (!this.deliveryDate) return;

    const days = Math.floor(Math.random() * 2) + 3; // 3-4 days
    const deliveryDate = new Date();

    // Add business days
    let addedDays = 0;
    while (addedDays < days) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      const dayOfWeek = deliveryDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Skip weekends
        addedDays++;
      }
    }

    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    this.deliveryDate.textContent = deliveryDate.toLocaleDateString('en-ZA', options);
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ScarcityTimer());
} else {
  new ScarcityTimer();
}